import { z } from "zod";

import { createEmailSchema } from "@/common-lib/forms/emailSchema";

const ERRORS = {
  school: "Select school, type ‘homeschool’ or tick ‘My school isn’t listed’",
  email: "Please enter a valid email address",
  name: "Please enter your name",
  eduRole: "Please enter your role",
} as const;

export const schoolIdSchema = z
  .string({
    error: () => ERRORS.school,
  })
  .min(1, ERRORS.school);

export const nameInputSchema = z
  .string({
    error: () => ERRORS.name,
  })
  .min(1, ERRORS.name);

export const emailRequiredSchema = createEmailSchema({
  emptyField: ERRORS.email,
  invalidField: ERRORS.email,
  type: ERRORS.email,
});

const schoolCombinedSchema = z
  .object({
    schoolId: schoolIdSchema.optional(),
    schoolNotListed: z.boolean(),
  })
  .superRefine((values, context) => {
    if (!values.schoolNotListed && values.schoolId === undefined) {
      context.addIssue({
        code: "custom",
        message: ERRORS.school,
        path: ["schoolId", "school"],
      });
    }
  });

export const partialNewsletterSchema = z.object({
  email: emailRequiredSchema,
  name: nameInputSchema,
});

export const newsletterSignupFormSubmitSchema = z.intersection(
  partialNewsletterSchema,
  schoolCombinedSchema,
);

export const newsletterSignupRoleSchema = z.object({
  eduRole: z
    .string({
      error: () => ERRORS.eduRole,
    })
    .min(1, ERRORS.eduRole),
});

export type CampaignNewsletterSignUpFormProps = z.infer<
  typeof newsletterSignupFormSubmitSchema
>;
